import { Pagination } from '@/constants/pagination';
import { EventType } from '@/types/event';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type EventState = {
  data: EventType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
};

export const eventInitialState: EventState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
};

const slice = createSlice({
  name: 'event',
  initialState: eventInitialState,
  reducers: {
    setListEventAction(
      state,
      action: PayloadAction<{
        data: EventType[];
        pagination?: PaginationAPI;
        totalExtend?: number;
      }>,
    ) {
      const { payload } = action;
      state.data = payload.data;

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },
  },
});

export const { setListEventAction } = slice.actions;
export default slice.reducer;
